/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useEffect, useState } from "react";
import { 
    Routes, 
    Route, 
    Navigate
} from "react-router-dom";
//#endregion
//#region Components
import ResourcesHome from "views/Recursos/ResourcesHome";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import { userHasPermission } from "config/userPermissions";
import { RESOURCE_MODULES } from "./utils/constants";
//#endregion
import useDashboardContext from "routes/utils/context/useDashboardContext";

const Resources = () => {
    const { user } = useDashboardContext();
    const userRole = user.role.id;
    //#region States
    const [routes, setRoutes] = useState(null);
    //#endregion
    //#region Effects
    useEffect(() => {
        setRoutes(getRoutes());
    }, []);
    //#endregion
    //#region Functions
    const getRoutes = () => {
        const newRoutes = [
            <Route 
                key={0}
                path="" 
                element={<ResourcesHome/>}/> 
        ];
        // Llenando rutas
        RESOURCE_MODULES.forEach(({
            id, path, View
        }) => {
            if (!userHasPermission(userRole, id)) return;
            newRoutes.push(
                <Route 
                    key={newRoutes.length}
                    path={path} 
                    element={<View/>}/>
            );
        });
        return newRoutes;
    }
    //#endregion
    return (
        <Routes>
            {routes}
            {routes !== null && (
                <Route 
                    path="*" 
                    element={
                        <Navigate 
                            to={ABSOLUTE_PATHS.RESOURCES} 
                            replace/>
                    }/>
            )}
        </Routes>
    );
}

export default Resources;